import type { CustomFlowbiteTheme } from 'flowbite-react';

export const badgeTheme: CustomFlowbiteTheme['badge'] = {
  root: {
    base: 'flex h-fit items-center gap-1 whitespace-nowrap',
    color: {
      info: 'bg-titan-blue-100 text-titan-blue-800 group-hover:bg-titan-blue-200',
      gray: 'bg-titan-night-100 text-titan-night-800 group-hover:bg-titan-night-200',
      failure:
        'bg-titan-folly-100 text-titan-folly-800 group-hover:bg-titan-folly-200',
      success: 'bg-green-100 text-green-800 group-hover:bg-green-200',
      warning:
        'bg-titan-yellow-100 text-titan-yellow-800 group-hover:bg-titan-yellow-200',
      indigo:
        'bg-titan-blue-100 text-titan-blue-800 group-hover:bg-titan-blue-200',
      purple:
        'bg-titan-folly-100 text-titan-folly-800 group-hover:bg-titan-folly-200',
    },
    href: 'group',
    size: {
      '2xs': 'px-1.5 text-xs',
      xs: 'p-2 text-xs',
      sm: 'p-3 text-sm',
    },
  },
  icon: {
    // No padding here — Badge always appends this (even with no `icon`
    // prop, which nothing in this app currently passes), and a fixed
    // padding here silently overrides `root.size`'s padding on every
    // badge because it's later in Badge's className merge order. Shape
    // only; `root.size` alone controls padding.
    off: 'rounded',
    on: 'rounded-full',
    size: {
      '2xs': 'w-3 h-3',
      xs: 'w-3 h-3',
      sm: 'w-3.5 h-3.5',
    },
  },
};
